export default __webpack_public_path__ + "static/media/no-video.22ec73ac.svg";